import { FormJson } from 'edocatbase/Form';
import { Action } from 'edocatbase/Global';
import formStateSwitch from './formStateSwitch';

const reducer = (state = {} as FormJson, action: Action) => {
  const innerFormInstanceId: string = action.innerFormInstanceId || action.meta?.innerFormInstanceId;

  if (innerFormInstanceId) {
    return {
      ...state,
      // @ts-ignore
      [innerFormInstanceId]: formStateSwitch(state?.[innerFormInstanceId] || {}, action),
    };
  }

  return formStateSwitch(state, action);
};

export default reducer;
